import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useContext, useMemo } from 'preact/compat';
import { BasketUpsellComboFormCTX } from '@basket/types/BasketUpsellComboFormContext';
import { OptionsCTX, optionsDefaults } from '@bookingForm/context/Options';
import { singleActivitySchema } from '@genericBookings/validation/schema';
import defaultValues from '@bookingForm/validation/defaultValues';
import StaticFormSteps from '@genericBookings/types/StaticFormSteps';
import Form from '@bookingForm/components/Form/Form';
import BookingFormWrapper from '@genericBookings/components/BookingFormWrapper';
import defaultTheme from '@bookingForm/themes/default';
import upsellTheme from '@bookingForm/themes/upsell';
import { Title } from '@widgets/UpsellModal/components/UpsellModalContent/styles';
function BookingForm({ onComplete }) {
    const { bookingForm, formTitle } = useContext(BasketUpsellComboFormCTX);
    const formOptions = useMemo(() => ({
        ...optionsDefaults,
        ...bookingForm,
        isMulti: false,
        isBuilder: false,
        debug: false,
        onComplete: () => onComplete(),
        redirect: false,
    }), [bookingForm, onComplete]);
    const theme = {
        ...defaultTheme,
        ...upsellTheme,
        layout: 'rework',
        themeName: 'upsell',
    };
    const { productId, hideQuickPayButtons } = formOptions;
    return (_jsxs(BookingFormWrapper, { schema: singleActivitySchema, defaultValues: {
            ...defaultValues,
            ProductId: productId ?? 217,
            acceptTerms: hideQuickPayButtons ? true : defaultValues.acceptTerms,
        }, steps: StaticFormSteps, theme: theme, OptionsCTX: OptionsCTX, options: formOptions, children: [formTitle && (_jsx(Title, { children: formTitle })), _jsx(Form, {})] }));
}
export default BookingForm;
